"use client"

import { BlockchainsMoleculeReatom } from "@/app/blockchains/blockchain-molecule.reatom"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useCollectionBlockchain } from "../store/use-collection"
import { EvmModernCollectionOfferDialogContent } from "./evm-modern-dialog-content.reatom"
import { SolanaModernCollectionOfferDialogContent } from "./solana-modern-dialog-content.reatom"

interface CollectionOfferDialogContentProps {
  onOpenChange: (isOpened: boolean) => void
}

export const CollectionOfferDialogContentReatom =
  reatomComponent<CollectionOfferDialogContentProps>(({ onOpenChange }) => {
    const blockchain = useCollectionBlockchain()
    const { reatomIsEvmBlockchain, reatomIsSolanaBlockchain } = useMolecule(
      BlockchainsMoleculeReatom,
    )

    // Call factory function with blockchain parameter
    const isEvmBlockchain = reatomIsEvmBlockchain()(blockchain)
    const isSolanaBlockchain = reatomIsSolanaBlockchain()(blockchain)

    if (isEvmBlockchain) {
      return (
        <EvmModernCollectionOfferDialogContent onOpenChange={onOpenChange} />
      )
    }

    if (isSolanaBlockchain) {
      return (
        <SolanaModernCollectionOfferDialogContent onOpenChange={onOpenChange} />
      )
    }
  }, "CollectionOfferDialogContentReatom")
